// extracted by mini-css-extract-plugin
export default {"control":"Product_control__o5YXB","richText":"Product_richText__C-1LV"};